import PropTypes from 'prop-types';
import RealtorCard from '@components/realtor-card';
import styles from './styles.module.scss';

const generateHeading = (queryParams) => {
  if (!queryParams) {
    return 'Agents Who Recently Listed or Sold';
  }

  // Priority: places > counties > schoolDistricts
  if (queryParams.places) {
    const place = Array.isArray(queryParams.places) ? queryParams.places[0] : queryParams.places;
    const locationName = place.split('_')[0].replace(/-/g, ' ');
    return `Agents Who Recently Listed or Sold in ${locationName}`;
  }

  if (queryParams.counties) {
    const county = Array.isArray(queryParams.counties)
      ? queryParams.counties[0]
      : queryParams.counties;
    const countyName = county.split('_')[0].replace(/-/g, ' ');
    return `Agents Who Recently Listed or Sold in ${countyName} County`;
  }

  if (queryParams.schoolDistricts) {
    const district = Array.isArray(queryParams.schoolDistricts)
      ? queryParams.schoolDistricts[0]
      : queryParams.schoolDistricts;
    return `Agents Who Recently Listed or Sold in ${district}`;
  }

  return 'Agents Who Recently Listed or Sold';
};

const RecentAgentsGrid = ({ agents, heading, queryParams }) => {
  if (!agents || agents.length === 0) {
    return null;
  }

  const displayHeading = heading || generateHeading(queryParams);

  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>{displayHeading}</h2>
      <div className={styles.grid}>
        {agents.map((agent) => (
          <RealtorCard
            key={agent.agentId}
            contact={agent}
            theme="horizontalLarge"
            showLicensedIn={true}
          />
        ))}
      </div>
    </section>
  );
};

RecentAgentsGrid.propTypes = {
  agents: PropTypes.arrayOf(
    PropTypes.shape({
      agentId: PropTypes.number.isRequired,
      displayPrimary: PropTypes.string.isRequired,
      displayPhotoUrl: PropTypes.string
      // RealtorCard expects full agent object with all CONTACT_ATTRIBUTES fields
    })
  ),
  heading: PropTypes.string,
  queryParams: PropTypes.object
};

export default RecentAgentsGrid;
